module.exports = __webpack_public_path__ + "d456bb19b630bc4e8cf9be2c581112ee.png";